import { useEffect } from 'react';

export const TermsOfService: React.FC = () => {
  useEffect(() => {
    // Redirect to Ministry Builders terms of service (brand-level policy)
    window.location.href = 'https://ministry.builders/terms';
  }, []);

  return (
    <div className="min-h-screen bg-dark-900 flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-4 border-accent-blue border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-dark-text">Redirecting to Ministry Builders Terms of Service...</p>
      </div>
    </div>
  );
};

export default TermsOfService;
